import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-email-verify-popup',
  templateUrl: './email-verify-popup.component.html',
  styleUrls: ['./email-verify-popup.component.scss']
})
export class EmailVerifyPopupComponent implements OnInit {
  @Output() resendClicked: EventEmitter<void> = new EventEmitter<void>();

  private matDialogRef: MatDialogRef<EmailVerifyPopupComponent>;
  public data: any;
  public enteredOtp: string;
  public resendEnabled: boolean = false;

  constructor(
    matDialogRef: MatDialogRef<EmailVerifyPopupComponent>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.matDialogRef = matDialogRef;
    this.data = data;
    this.resendEnabled = data.resendEnabled ? data.resendEnabled : false;
  }

  ngOnInit(): void { }

  handleOtpClick(value: string) {
    this.enteredOtp = value;
  }

  onBackButtonClicked() {
    this.matDialogRef.close();
  }

  onVerifyClicked() {
    return this.matDialogRef.close(this.enteredOtp);
  }

  isVerifyButtonDisabled(): boolean {
    return this.enteredOtp && this.enteredOtp.length === 6 ? false : true; 
  }

  OnResendOtpClicked() {
    this.resendClicked.emit();
  }
}
